import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PlanDetails from './pages/PlanDetails';
import PlanAnalysisScroll from './components/PlanAnalysisScroll';
import PlanEstimatorPage from './components/PlanEstimatorPage';
import PlanSponsorIntake from './components/PlanSponsorIntake';
import Research from './pages/Research';
import Prospecting from './pages/Prospecting';
import CohortAnalysis from './pages/CohortAnalysis';
import BetaLogin from './components/BetaLogin';
import AdminRoute from './components/AdminRoute';
import BlogWriter from './components/BlogWriter';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if beta login is enabled via environment variable
  const betaLoginEnabled = true;  // Force beta login ON for production

  useEffect(() => {
    // Check if already authenticated in this session
    if (betaLoginEnabled) {
      const authenticated = sessionStorage.getItem('beta_authenticated');
      if (authenticated === 'true') {
        setIsAuthenticated(true);
      }
    } else {
      // If beta login is disabled, automatically authenticate
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [betaLoginEnabled]);

  // Show loading state briefly
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        Loading...
      </div>
    );
  }

  // Show login page if beta login is enabled and user is not authenticated
  if (betaLoginEnabled && !isAuthenticated) {
    return <BetaLogin onLogin={setIsAuthenticated} />;
  }

  // Show the main app
  return (
    <Router>
      <div className="App">
        {/* Main Content */}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* New scroll-based analysis page (for testing) */}
            <Route path="/plan-analysis/:ein/:planNumber/:planYear" element={<PlanAnalysisScroll />} />
            {/* Original tabbed plan details page */}
            <Route path="/plan/:ein/:planNumber/:planYear" element={<PlanDetails />} />
            <Route path="/estimator" element={<PlanEstimatorPage />} />
            <Route path="/sponsor-intake" element={<PlanSponsorIntake />} />
            {/* Admin-only routes */}
            <Route path="/admin/research" element={<AdminRoute><Research /></AdminRoute>} />
            <Route path="/admin/prospecting" element={<AdminRoute><Prospecting /></AdminRoute>} />
            <Route path="/admin/cohort" element={<AdminRoute><CohortAnalysis /></AdminRoute>} />
            <Route path="/admin/blog-writer" element={<AdminRoute><BlogWriter /></AdminRoute>} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
